import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ children, variant = 'primary', className = '', ...props }) => {
    const variants = {
        primary: `bg-[#EA723D] text-white shadow-lg shadow-orange-900/20`,
        secondary: `bg-[#2C353D] text-white shadow-lg shadow-gray-900/20`,
        outline: `border-2 border-[#EA723D] text-[#EA723D] hover:bg-[#EA723D] hover:text-white focus:outline-none focus:ring-2 focus:ring-[#EA723D] focus:ring-offset-2`,
        ghost: `text-[#2C353D] hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2`,
        custom: `` // No default backgrounds or text colors
    };

    return (
        <motion.button
            whileHover={{
                y: -4,
                scale: 1.02,
                boxShadow: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
            }}
            whileTap={{ scale: 0.98 }}
            className={`relative overflow-hidden px-6 py-3 rounded-lg text-sm uppercase tracking-wide font-bold transition-all duration-300 flex items-center justify-center gap-2 ${variants[variant]} ${className} group focus:outline-none focus:ring-2 focus:ring-offset-2 ${variant === 'primary' ? 'focus:ring-[#EA723D]' : variant === 'secondary' ? 'focus:ring-[#2C353D]' : ''}`}
            {...props}
        >
            {/* Shimmer effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-shimmer" />

            <span className="relative z-10 flex items-center gap-2">
                {children}
            </span>
        </motion.button>
    );
};

export default Button;
